import React from 'react';
import ResultItemMob from './statisticItem';

function GameResultsMobile({
  resultsContainer,
  memoWinBetTypes,
  columnsCount,
  pseudoWinBetTypesIds,
  winBetTypesIds,
}) {
  return (
    <div className='betting-block-sheet' ref={resultsContainer}>
      <div className='left-column-sheet'>
        {!memoWinBetTypes || columnsCount.length > memoWinBetTypes.length
          ? columnsCount.map((item, index) => {
              return (
                <ResultItemMob
                  key={pseudoWinBetTypesIds[index]}
                  roundData={memoWinBetTypes?.[index]?.roundData || {}}
                />
              );
            })
          : memoWinBetTypes.map((item, index) => {
              return (
                <ResultItemMob
                  key={winBetTypesIds[index]}
                  roundData={memoWinBetTypes?.[index]?.roundData || {}}
                />
              );
            })}
      </div>
    </div>
  );
}

export default GameResultsMobile;
